export default "__VITE_ASSET__CreHrrJd__"